import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { CatalogForm } from "../CatalogForm";
import { EditCatalogModalProps } from "./types";
import { useEditCatalogModal } from "./controller";

export const EditCatalogModal = React.memo(({ modalRef, onComplete  }: EditCatalogModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditCatalogModal(modalRef, onComplete);

  return (
    <Modal
      ref={modalRef}
      title={translate("catalog.titles.edit")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <CatalogForm />
    </Modal>
  );
});
